import TextInputField from './TextField';
import TextareaField from './TextareaField';
import HtmlField from './HtmlField';
import NumberField from './NumberField';
import CountryField from './CountryField';
import ContinentField from './ContinentField';
import KeyHighlightsField from './KeyHighlightsField';
import CityAutocompleteField from './CityAutocompleteField';
import PhoneField from './PhoneField';
import DropdownField from './DropdownField';
import ConfigurableDropdownField from './ConfigurableDropdownField';
import DateField from './DateField';
import DateTimeField from './DateTimeField';
import TimeField from './TimeField';
import CurrencySelectField from './CurrencySelectField';
import CheckboxField from './CheckboxField';
import MultiSelectField from './MultiSelectField';
import ImageUploadField from './ImageUploadField';
import TemplateSelectField from './TemplateSelectField';
import RepeatableFormField from './RepeatableFormField';
import HssSelectField from './HssSelectField';
import ComponentSelectField from './ComponentSelectField';
import DiscountCalcField from './DiscountCalcField';
import DurationCalcField from './DurationCalcField';
import DaySelectField from './DaySelectField';
import AddressAutocompleteField from './AddressAutocompleteField';
import SearchableLookupField from './SearchableLookupField';
import TripSelectionField from './TripSelectionField';
import AddonExtensionScheduleField from './AddonExtensionScheduleField';


/** Map of stepsConfig field.type -> renderer component */
export const FIELD_RENDERERS = {
    text: TextInputField,
    textarea: TextareaField,
    html: HtmlField,
    number: NumberField,
    country: CountryField,
    continent: ContinentField,
    'trip-selection': TripSelectionField,
    'key-highlights': KeyHighlightsField,
    'city-autocomplete': CityAutocompleteField,
    phone: PhoneField,
    dropdown: DropdownField,
    'configurable-dropdown': ConfigurableDropdownField,
    date: DateField,
    datetime: DateTimeField,
    time: TimeField,
    'currency-select': CurrencySelectField,
    checkbox: CheckboxField,
    'multi-select': MultiSelectField,
    'image-upload': ImageUploadField,
    'template-select': TemplateSelectField,
    'repeatable-form': RepeatableFormField,
    'hss-select': HssSelectField,
    'component-select': ComponentSelectField,
    'discount-calc': DiscountCalcField,
    'duration-calc': DurationCalcField,
    'day-select': DaySelectField,
    'address-autocomplete': AddressAutocompleteField,
    'searchable-lookup': SearchableLookupField,
    'addon-extension-schedule': AddonExtensionScheduleField,
};

export default FIELD_RENDERERS;
